import { createQueryKeys } from "@lukemorales/query-key-factory";

import { listOrganizationProviders } from "../api/providers";

export const organizationProvidersQueryOptionsFactory = createQueryKeys(
  "organization-providers",
  {
    list: (organizationId: string) => ({
      queryKey: [organizationId],
      queryFn: () => listOrganizationProviders(organizationId),
    }),
  },
);
